import React, { useMemo } from 'react'
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux'
import moment from 'moment'
import 'moment/locale/ru';
import { formViewProps, formName } from '../gant.const'
import { formDateSelector, todayString } from '../utils/dateHelpers';

const useStyles = makeStyles(theme => ({
  sticky: {
    position: 'sticky',
    top: 0,
  },
}));
// шапка с датами ---------------------------------------
export default function DateLine({ zoom, sizeDay, sizeWeek, sizeMonth, heightDateLine }) {
  const classes = useStyles()
  const startRaw = useSelector(formDateSelector(formName, 'start')) || todayString();
  const endRaw = useSelector(formDateSelector(formName, 'end')) || todayString()
  const { arr, countDay, daysToWeekend } = useMemo(() => {
    const start = moment(startRaw,'YYYY-MM-DD');
    const end = moment(endRaw,'YYYY-MM-DD');
    const countDay = end.diff(start, 'days') + 10;
    let date = moment(start);
    const res = {
      [date.format('MMMM YYYY')]: [{
        d: date.format('D'),
        day: date.day(),
        m: date.format('MMM')
      }]
    };

    for (let i = 0; i < countDay; i++) {
      date = date.clone().add(1, 'd');
      const key = date.format('MMMM YYYY');
      if (res[key]) {
        res[key].push({ d: date.format('D'), day: date.day(), m: date.format('MMM') });
      } else {
        res[key] = [{ d: date.format('D'), day: date.day(), m: date.format('MMM') }];
      }
    }

    const startWeekend = moment(start).day(7);
    const daysToWeekend = (startWeekend.diff(start, 'days')) % 7 - 1;

    return { arr: res, countDay, daysToWeekend };
  }, [startRaw, endRaw]);
  const startDiag = useSelector(formSelector(formViewProps, 'startDiag')) || 1810
  let gantComponent = null
  switch (zoom) {
    case 'day': {
      gantComponent = <DateLineDay
        arr={arr}
        countDay={countDay}
        daysToWeekend={daysToWeekend}
        heightDateLine={heightDateLine}
        startDiag={startDiag}
        sizeDay={sizeDay}
      />
      break;
    }
    case 'week': {
      gantComponent = <DateLineWeek
        arr={arr}
        heightDateLine={heightDateLine}
        startDiag={startDiag}
        sizeWeek={sizeWeek}
        sizeDay={sizeDay}
      />
      break;
    }
    case 'month': {
      gantComponent = <DateLineMonth
        arr={arr}
        heightDateLine={heightDateLine}
        sizeDay={sizeDay}
        sizeMonth={sizeMonth}
      />
      break;
    }
    default: { break; }
  }
  return <g id="sticky-rect" className={classes.sticky}  >
    {gantComponent}
  </g>
}
function DateLineMonth({ arr, heightDateLine, sizeDay, sizeMonth }) {
  const startDiag = useSelector(formSelector(formViewProps, 'startDiag')) || 1810
  let offset = startDiag
  const sizeD = sizeMonth * 12 / 365
  const yearArr = {}
  Object.keys(arr).forEach(m => {
    const mSplit = m.split(' ')
    if (yearArr[mSplit[1]]) yearArr[mSplit[1]].push({ label: mSplit[0], size: arr[m].length })
    else yearArr[mSplit[1]] = [{ label: mSplit[0], size: arr[m].length }]
  })
  return <>
    {Object.keys(yearArr).map((year) => {
      const months = yearArr[year]
      let sizeYear = 0
      months.forEach(e => { sizeYear += e.size })
      offset += sizeD * sizeYear
      let offsetMonth = 0
      return <g key={year} transform={`translate(${offset - sizeD * sizeYear})`}>
        <rect
          x={0}
          y={0}
          stroke="#a6a6a6"
          strokeWidth="1"
          fill="white"
          width={sizeD * sizeYear}
          height={heightDateLine - sizeDay}
        />
        <text
          dominantBaseline="middle"
          textAnchor="middle"
          x={sizeD * sizeYear / 2}
          y={(heightDateLine - sizeDay) / 2}
        >{year}</text>
        {months.map((m, i) => {
          const sizeMonthD = m.size * sizeD
          offsetMonth += sizeMonthD
          return <React.Fragment key={i}>
            <rect
              x={offsetMonth - sizeMonthD}
              y={sizeDay}
              stroke="#a6a6a6"
              strokeWidth="1"
              fill="white"
              width={sizeMonthD}
              height={sizeDay}
            />
            <text
              x={offsetMonth - sizeMonthD + sizeMonthD / 2}
              y={heightDateLine - sizeDay + sizeDay / 2}
              dominantBaseline="middle"
              textAnchor="middle"
            >{m.label}</text>
          </React.Fragment>
        })}
      </g>
    })}
  </>
}
function DateLineWeek({ arr, heightDateLine, startDiag, sizeWeek, sizeDay }) {
  let offset = startDiag
  const months = Object.keys(arr).map((month) => {
    const days = arr[month];
    const firstDay = days[0];
    const firstDayOfWeek = firstDay.day;
    const mondays = days.filter((e) => e.day === 1);
    const weekStarts = [];
    if (firstDayOfWeek !== 1) {
      weekStarts.push({
        d: firstDay.d,
        m: firstDay.m,
        day: firstDayOfWeek,
        isVirtual: true
      });
    }
    weekStarts.push(...mondays);
    const week = weekStarts.map((start, index) => {
      const startIndex = days.findIndex((d) => d.d === start.d);
      const nextStartIndex = index < weekStarts.length - 1
        ? days.findIndex((d) => d.d === weekStarts[index + 1].d)
        : days.length;
      const daysCount = nextStartIndex - startIndex;

      return {
        ...start,
        daysCount
      };
    });
    const incWeek = (days.length * sizeWeek) / 7;
    return { month, days, week, incWeek };
  });

  const monthsWithOffset = months.map((m) => {
    const result = { ...m, offset };
    offset += m.incWeek;
    return result;
  });
  return <>
    {monthsWithOffset.map(({ month, days, incWeek, offset }) => (
      <g key={`month-${month}`} transform={`translate(${offset}, 0)`}>
        <rect
          x={0}
          y={0}
          stroke="#a6a6a6"
          strokeWidth="1"
          fill="white"
          width={incWeek}
          height={heightDateLine - sizeDay}
        />
        <text
          dominantBaseline="middle"
          textAnchor="middle"
          x={incWeek / 2}
          y={(heightDateLine - sizeDay) / 2}
        >
          {days.length > 1 ? month : moment().month(month).format("MMM")}
        </text>
      </g>
    ))}

    {monthsWithOffset.map(({ month, week, offset }) => {
      let weekX = offset;
      return week.map((w, i) => {
        const width = (w.daysCount / 7) * sizeWeek;
        const x = weekX;
        weekX += width;
        return (
          <g
            key={`week-${month}-${w.d}`}
            transform={`translate(${x}, ${heightDateLine - sizeDay})`}
          >
            <rect
              x={0}
              y={0}
              width={width}
              height={sizeDay}
              stroke="#a6a6a6"
              strokeWidth="1"
              fill="white"
            />
            <text
              dominantBaseline="middle"
              textAnchor="middle"
              x={width / 2}
              y={sizeDay / 2}
              fontSize={w.isVirtual ? "10" : "12"}
            >
              {w.d}
            </text>
          </g>
        );
      });
    })}
  </>
}
function DateLineDay({ arr, countDay, daysToWeekend, heightDateLine, startDiag, sizeDay }) {
  let offset = startDiag
  return <>
    <g transform={`translate(${startDiag})`}>
      <rect
        x={0}
        y={sizeDay}
        fill="white"
        width={sizeDay * (countDay + 1)}
        height={sizeDay}
        stroke='#a6a6a6'
        strokeWidth={1}
      />
      <rect
        x={0}
        y={sizeDay}
        fill="url(#patternHeaderGanttDay)"
        width={sizeDay * countDay}
        height={sizeDay}
        transform={`translate(${sizeDay / 2})`}
      />
      <rect
        x={0}
        y={sizeDay}
        fill="url(#patternHeaderGanttDayWeekend)"
        width={sizeDay * countDay}
        height={sizeDay}
        transform={`translate(${sizeDay * daysToWeekend},0)`}
        stroke='none'
      />

    </g>
    {Object.keys(arr).map((month) => {
      const days = arr[month]
      offset += sizeDay * days.length
      return <g key={month} transform={`translate(${offset - sizeDay * days.length})`}>
        <rect
          x={0}
          y={0}
          stroke="#a6a6a6"
          strokeWidth="1"
          fill="white"
          width={sizeDay * days.length}
          height={heightDateLine - sizeDay}
        />
        <text
          dominantBaseline="middle"
          textAnchor="middle"
          x={sizeDay * days.length / 2}
          y={(heightDateLine - sizeDay) / 2}
        >{days.length > 1 ? month : moment().month(month).format('MMM')}</text>
        {days.map((day, i) => {
          return <React.Fragment key={i}>
            <text
              x={i * sizeDay + sizeDay / 2}
              y={heightDateLine - sizeDay + sizeDay / 2}
              dominantBaseline="middle"
              textAnchor="middle"
            >{day.d}</text>
          </React.Fragment>
        })}
      </g>
    })}
  </>
}
function formSelector(formName, field) {
  return state => state.form?.[formName]?.values[field]
}